module.exports = __webpack_public_path__ + "media/newstyle/images/stars_5-orange-0d672336f8933a93a858b01a94c5268e.svg";